import {
  Box,
  DialogContent,
  DialogTitle,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { customerBusiness } from "api/bussiness/customer/customer-bussiness";
import {
  DeliveryAddresses,
  UpdateCustomer,
} from "api/models/request/customer/customer";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { DynamicFormArray } from "commons/ultilities/dynamic-form/components/dynamic-form-array";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { IControl } from "commons/ultilities/dynamic-form/models/control";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect, useMemo } from "react";
import { AddButton } from "share-components/mui-wrap/button/action-button";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { customerFormSchema } from "../schema";

export const EditCustomer = observer(() => {
  const {
    customerManagement: {
      openEdit,
      setProp,
      customerDetail,
      getCustomerDetail,
    },
    catalogueStore: {
      getCustomerTypes,
      customerTypes,
      cataloguesToOptionItems,
    },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    getControlArray,
    submitHandler,
  } = useForm<UpdateCustomer>(customerFormSchema(), {
    code: customerDetail?.code || "",
    name: customerDetail?.name || "",
    dealingName: customerDetail?.dealingName || "",
    customerTypeId: customerDetail?.customerTypeId || "",
    headOfficeAddress: customerDetail?.headOfficeAddress || "",
    note: customerDetail?.note || "",
    taxCode: customerDetail?.taxCode || "",
    isDisabled: customerDetail?.isDisabled || false,
    deliveryAddresses:
      customerDetail?.deliveryAddresses.map((x) => {
        return {
          id: x.id,
          address: x.address || "",
        } as DeliveryAddresses;
      }) || [],
  });

  const deliveryAddressesFormArray = useMemo(() => {
    return getControlArray("deliveryAddresses");
  }, [getControlArray]);

  const saveHandler = useCallback(
    async (data: UpdateCustomer) => {
      try {
        if (!customerDetail?.id) return;
        await customerBusiness.update(customerDetail?.id, data);
        await getCustomerDetail(customerDetail?.id);

        setProp("openEdit", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [customerDetail?.id, getCustomerDetail, setProp]
  );

  useEffect(() => {
    getCustomerTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (customerTypes) {
      const options = cataloguesToOptionItems(customerTypes);
      const control = getControl("customerTypeId");
      control.setProp("optionItems", options);
    }
  }, [cataloguesToOptionItems, customerTypes, getControl]);

  return (
    <DialogForm
      open={openEdit}
      fullWidth
      maxWidth={"md"}
      onClose={() => setProp("openEdit", false)}
      onCancelBtnClicked={() => setProp("openEdit", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Sửa khách hàng</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>

          <DeliveryAddressesFormArray
            deliveryAddressesControl={getControl("deliveryAddresses")}
            deliveryAddressesFormArray={deliveryAddressesFormArray}
          ></DeliveryAddressesFormArray>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});
type DeliveryAddressesProps = {
  deliveryAddressesControl: IControl;
  deliveryAddressesFormArray: IControl[][];
};
const DeliveryAddressesFormArray = observer(
  ({
    deliveryAddressesFormArray,
    deliveryAddressesControl,
  }: DeliveryAddressesProps) => {
    const onAddMoreDeliveryAddress = useCallback(() => {
      deliveryAddressesControl.addNewChild();
    }, [deliveryAddressesControl]);

    const removeRowHandler = useCallback(
      (rowIdx: number) => {
        deliveryAddressesControl.removeChildByIndex(rowIdx);
      },
      [deliveryAddressesControl]
    );
    return (
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Stack
            direction={"row"}
            spacing={1}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography variant="subtitle2">
              {deliveryAddressesControl.label}
            </Typography>
            <AddButton onClick={onAddMoreDeliveryAddress}></AddButton>
          </Stack>
        </Grid>
        <Grid item xs={12}>
          {deliveryAddressesFormArray &&
            deliveryAddressesFormArray.length > 0 && (
              <DynamicFormArray
                children={deliveryAddressesFormArray}
                onRemoveRowClick={removeRowHandler}
              ></DynamicFormArray>
            )}
        </Grid>
      </Grid>
    );
  }
);
